var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "visitor-detail-page" } },
    [
      _c("AppBreadCrumb", {
        staticClass: "visitor-detail-bread-crumb",
        attrs: {
          paths: [{ title: _vm.$t("visitor.visitorDetail") }],
          select: true,
        },
      }),
      _vm._v(" "),
      _c("VisitorDetail", {
        attrs: { visitorId: _vm.visitorId, visibleMail: false },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }